import { byteToKb, byteToMb } from 'common/utils/byteConvert'

export const formatMediaSize = (byte: number, accuracy: number) => {
  const kb = byteToKb(byte, accuracy)
  const mb = byteToMb(byte, accuracy)
  return kb < 1000 ? `${kb} KB` : `${mb} MB`
}
